import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AlertSeeker } from "@ui-seeker/core"

import { country, retailer } from "@signals"


export default function CatalogueAnalyzerOverviewTableWarning() {
	const isOpen = useSignal(true)

    if (country.value?.length === 1)
         return <></>

	return <Box sx={{ width: 1 }}>
		<AlertSeeker
			isOpen={isOpen.value}
			severity="warning"
			controller={() => isOpen.value = !isOpen.value}
			title="Warning Overview Table"
			open={true}
		>
			Overview table is only available within single country filters.
		</AlertSeeker>
	</Box>  
}